export const isAvailableData = { isAvailable: false };
